export default `---
slug: monreader
title: "MonReader"
year: 2023
category: personal
featured: false
tags: [Python, CNN, RNN, PyTorch, Transfer Learning, Computer Vision, Apziva]
thumbnail: /images/projects/16_vecho_cnn.png
description: "Document page detection with CNNs (98% F1) and sequence classification with RNNs — bulk document scanning made smart."
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the fourth project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with Claude, who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/MonReader)) covered Computer Vision, a field I was already familiar with; hence, I went over this project quickly, to have more times on topics I was less experienced with.

![Student in NL doing CNNs](/images/projects/16_vecho_cnn.png)

This project aimed to provide a seamless mobile document digitization experience, allowing for efficient bulk document scanning.
I had to tackle two main tasks: Document page detection and Sequence classification.

**Document Page Detection**

- The goal was predicting whether a book's page is being flipped using just a single image.
- I engineered a Convolutional Neural Network (CNN) using the PyTorch module, demonstrating the power of deep learning.
- With this technique, I achieved remarkable results surpassing the baseline model's performance, boasting an impressive 98% F1 score.
- To play around a bit, I also reduced the model size by up to 5 times while maintaining an F1 score above 90%.

**Sequence Classification**

- In the second phase of the project, I shifted the focus to classifying entire sequences instead of individual frames.
- I leveraged the single-frame model as a benchmark, modifying it to generate sequence outputs through average or max pooling techniques.
- I also tried to employ a Recurrent Neural Network (RNN) to establish sequence memory, enhancing performance through the strategic addition of skip connections, resulting in an impressive 88.8% F1 score.
- To expedite training (*and to have some fun*), I applied transfer learning to the CNN component of the model, further optimizing performance with a 96.9% F1 score.

It goes without saying that I did the project in Python, using Google computing power (*Colab one love*).
I would love to tell you more about the project, but I don't really remember and I am too lazy to check the Jupyter notebook - it is linked at the top, if you are curious go check it out!
`;
